export enum Locales {
  en = "en",
  ru = "ru",
  lv = "lv",
}